<template>
  <div class="drop-board" :class="{ [position + '-drop-board']: true }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      validator: function (value) {
        return [ 'top', 'right', 'bottom', 'left' ].indexOf(value) !== -1
      }
    }
  }
}
</script>

<style scoped>
.drop-board { background: #fff; /* border-radius: 5px; */ box-shadow: 0 0 3px rgba(0, 0, 0, .5); color: #2c3e50; margin-top: 7px; position: absolute; z-index: 10000; font-size: 12px; font-weight: bold; }
.drop-board:before { content: ''; position: absolute; z-index: 10001; }
.bottom-drop-board:before { border: 5px solid transparent; border-bottom: 5px solid #fff; top: -9px; }
</style>



// WEBPACK FOOTER //
// src/components/DropBoard.vue